import React, { useState } from 'react';
import { Check, Send } from 'lucide-react';
export function ContactForm() {
  const [activeTab, setActiveTab] = useState<'achat' | 'vente'>('achat');
  return <section id="contact" className="py-24 bg-gradient-to-b from-gray-50 to-white relative overflow-hidden" data-id="element-11">
      {/* Decorative blobs */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-primary/5 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" data-id="element-12"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-accent/5 rounded-full blur-3xl translate-x-1/3 translate-y-1/3" data-id="element-13"></div>

      <div className="w-full max-w-[1000px] mx-auto px-6 relative z-10" data-id="element-14">
        <div className="text-center mb-12" data-id="element-15">
          <span className="text-primary font-semibold tracking-wider uppercase text-sm" data-id="element-16">
            Contactez-nous
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-secondary-dark mt-3 mb-6" data-id="element-17">
            Parlons de votre projet
          </h2>
          <p className="text-lg text-gray-500 max-w-2xl mx-auto" data-id="element-18">
            Une équipe dédiée vous répond sous 2h ouvrées. Devis gratuit et sans
            engagement.
          </p>
        </div>

        <div className="bg-white rounded-3xl shadow-xl shadow-gray-200/50 border border-gray-100 overflow-hidden" data-id="element-19">
          <div className="flex border-b border-gray-100" data-id="element-20">
            <button onClick={() => setActiveTab('achat')} className={`
                flex-1 py-6 text-center font-semibold text-lg transition-all relative
                ${activeTab === 'achat' ? 'text-primary bg-white' : 'text-gray-400 bg-gray-50 hover:text-gray-600'}
              `} data-id="element-21">
              Je veux acheter
              {activeTab === 'achat' && <div className="absolute bottom-0 left-0 w-full h-1 bg-primary" data-id="element-22"></div>}
            </button>
            <button onClick={() => setActiveTab('vente')} className={`
                flex-1 py-6 text-center font-semibold text-lg transition-all relative
                ${activeTab === 'vente' ? 'text-primary bg-white' : 'text-gray-400 bg-gray-50 hover:text-gray-600'}
              `} data-id="element-23">
              Je veux vendre
              {activeTab === 'vente' && <div className="absolute bottom-0 left-0 w-full h-1 bg-primary" data-id="element-24"></div>}
            </button>
          </div>

          <div className="p-8 md:p-12" data-id="element-25">
            <form action="https://formspree.io/f/movpdpwa" method="POST" className="space-y-8" data-id="element-26">
              <input type="hidden" name="_subject" value={`Nouvelle demande ${activeTab} - 1001palettes.com`} data-id="element-27" />
              <input type="hidden" name="type-demande" value={activeTab} data-id="element-28" />

              <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-29">
                <div className="space-y-2" data-id="element-30">
                  <label htmlFor="entreprise" className="block text-sm font-semibold text-secondary-dark" data-id="element-31">
                    Entreprise <span className="text-red-500" data-id="element-32">*</span>
                  </label>
                  <input type="text" id="entreprise" name="entreprise" required className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all" placeholder="Nom de votre société" data-id="element-33" />
                </div>
                <div className="space-y-2" data-id="element-34">
                  <label htmlFor="nom" className="block text-sm font-semibold text-secondary-dark" data-id="element-35">
                    Contact <span className="text-red-500" data-id="element-36">*</span>
                  </label>
                  <input type="text" id="nom" name="nom" required className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all" placeholder="Votre nom complet" data-id="element-37" />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-38">
                <div className="space-y-2" data-id="element-39">
                  <label htmlFor="email" className="block text-sm font-semibold text-secondary-dark" data-id="element-40">
                    Email professionnel <span className="text-red-500" data-id="element-41">*</span>
                  </label>
                  <input type="email" id="email" name="email" required className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all" placeholder="email@societe.com" data-id="element-42" />
                </div>
                <div className="space-y-2" data-id="element-43">
                  <label htmlFor="telephone" className="block text-sm font-semibold text-secondary-dark" data-id="element-44">
                    Téléphone
                  </label>
                  <input type="tel" id="telephone" name="telephone" className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all" placeholder="06 12 34 56 78" data-id="element-45" />
                </div>
              </div>

              <div className="space-y-4" data-id="element-46">
                <label className="block text-sm font-semibold text-secondary-dark" data-id="element-47">
                  Type de palettes <span className="text-red-500" data-id="element-48">*</span>
                </label>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4" data-id="element-49">
                  {[{
                  val: 'bois-neuves',
                  label: 'Bois Neuves'
                }, {
                  val: 'bois-occasion',
                  label: 'Bois Occasion'
                }, {
                  val: 'plastique-neuves',
                  label: 'Plastique Neuves'
                }, {
                  val: 'plastique-occasion',
                  label: 'Plastique Occasion'
                }].map(item => <label key={item.val} className="relative cursor-pointer group" data-id="element-50">
                      <input type="checkbox" name="palettes[]" value={item.val} className="peer sr-only" data-id="element-51" />
                      <div className="p-4 rounded-xl border border-gray-200 bg-white text-center transition-all peer-checked:border-primary peer-checked:bg-primary-light/10 peer-checked:text-primary-dark hover:border-primary/50" data-id="element-52">
                        <span className="text-sm font-medium" data-id="element-53">
                          {item.label}
                        </span>
                      </div>
                      <div className="absolute top-2 right-2 opacity-0 peer-checked:opacity-100 transition-opacity text-primary" data-id="element-54">
                        <Check size={14} strokeWidth={3} data-id="element-55" />
                      </div>
                    </label>)}
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-56">
                <div className="space-y-2" data-id="element-57">
                  <label htmlFor="codepostal" className="block text-sm font-semibold text-secondary-dark" data-id="element-58">
                    Code postal <span className="text-red-500" data-id="element-59">*</span>
                  </label>
                  <input type="text" id="codepostal" name="codepostal" required className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all" placeholder="75000" data-id="element-60" />
                </div>
                <div className="space-y-2" data-id="element-61">
                  <label htmlFor="quantite" className="block text-sm font-semibold text-secondary-dark" data-id="element-62">
                    Volume estimé
                  </label>
                  <input type="text" id="quantite" name="quantite" className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all" placeholder="Ex: 500 palettes/mois" data-id="element-63" />
                </div>
              </div>

              <div className="space-y-2" data-id="element-64">
                <label htmlFor="message" className="block text-sm font-semibold text-secondary-dark" data-id="element-65">
                  Détails de votre demande{' '}
                  <span className="text-red-500" data-id="element-66">*</span>
                </label>
                <textarea id="message" name="message" rows={4} required placeholder="Décrivez votre besoin spécifique, vos contraintes logistiques, vos délais..." className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all resize-y" data-id="element-67"></textarea>
              </div>

              <button type="submit" className="w-full py-4 bg-primary text-white font-bold text-lg rounded-xl hover:bg-primary-dark hover:shadow-lg hover:shadow-primary/30 transition-all duration-300 flex items-center justify-center gap-3 group" data-id="element-68">
                Envoyer ma demande
                <Send size={20} className="group-hover:translate-x-1 transition-transform" data-id="element-69" />
              </button>

              <p className="text-center text-xs text-gray-400 mt-4" data-id="element-70">
                En soumettant ce formulaire, vous acceptez notre politique de
                confidentialité. Vos données sont sécurisées.
              </p>
            </form>
          </div>
        </div>
      </div>
    </section>;
}